﻿// Disable zip and link radios if the bedroom is not selected.
$(function () {
    // Keeps track of the number of rooms left to configure.
    function RoomConfigTotals(el) {
        var _this = this;
        _this.el = el;
        _this.inputs = null;
        
        _this.activate = function () {
            if (_this.el === null) {
                return;
            }
            _this.inputs = $(_this.el).find('[type="checkbox"]');
            if (_this.inputs.length === 0) {
                return;
            }  
            $(_this.inputs).change(function (e) {
                _this.update();
            });
            _this.update();
        };
        _this.update = function () {
            var requiredElement = $('#RoomConfigCountRequired');
            if (requiredElement === null) {
                return;
            }
            requiredElement = requiredElement[0];
            var required = parseInt($(requiredElement).text(), 10);
            var count = _this.el.find('[type="checkbox"]:checked').length;
            var remaining = required - count;
            var bedroomText = '';
            if (remaining === 1) {
                bedroomText = "bedroom";
            } else {
                bedroomText = "bedrooms";
            }
            _this.el.find('[type="checkbox"]').removeAttr('disabled');
            $('#RoomConfigFeedback').removeClass('complete');
            $('#RoomConfigFeedback').html("<p>Choose <b>" + String(remaining) + "</b> more " + bedroomText + ".</p>");
            if (remaining === 0) {
                _this.el.find('[type="checkbox"]:not(:checked)').attr('disabled', true);
                $('#RoomConfigFeedback').addClass('complete');
                $('#RoomConfigFeedback').html('<p>Correct number of bedrooms chosen.</p>');
            }
        };
    }
    function RoomConfigRow(el) {
        var _this = this;
        _this.el = el;
        _this.radios = null;
        _this.ul = null;
        _this.p = null;
        _this.activate = function () {
            if (_this.el === null) {
                return;
            }
            var input = $(this.el).children('[type="checkbox"]');
            if (input.length === 0) {
                return;
            }
            input = input[0];
            _this.radios = $(_this.el).find('[type="radio"]');
            _this.ul = $(_this.el).find('ul');
            _this.p = $(_this.el).find('p');
            if (input.checked) {
                $(_this.radios).removeAttr('disabled');
                $(_this.ul).removeClass('hidden');
                $(_this.p).removeClass('hidden');
            } else {
                $(_this.radios).attr('disabled', true);
                $(_this.ul).addClass('hidden');
                $(_this.p).addClass('hidden');
            }
            $(input).change(function (e) {
                if (e.currentTarget.checked) {
                    $(_this.radios).removeAttr('disabled');
                    $(_this.ul).removeClass('hidden');
                    $(_this.p).removeClass('hidden');
                } else {
                    $(_this.radios).attr('disabled', true);
                    $(_this.ul).addClass('hidden');
                    $(_this.p).addClass('hidden');
                }
            });
        };
    }
    try {
        $('.bedroom-config-row').each(function (idx, el) {
            var row = new RoomConfigRow(el);
            row.activate();
        });
        var totalEl = $('#RoomConfigContainer');
        if (totalEl !== null) {
            var totals = new RoomConfigTotals(totalEl);
            totals.activate();
        }
    } catch (e) {
        console.log(e);
    }
});